export default __webpack_public_path__ + "static/media/checkMark.54205924.svg";